angular.module('common.directives').directive('profileDropdown', function () {
  return {
    scope: {
      section: '='
    },
    templateUrl: './templates/profileDropdown.view.html?t=' + webpackHash,
    controller: 'profileDropdownCtrl',
    link: function ($scope, $element) {}
  }
})
